var _path, _path2, _rect, _path3, _path4, _rect2, _rect3, _ellipse, _ellipse2, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTongkang(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0842 27.4448C15.544 27.4448 11.3041 29.5495 8.78563 33.0535L8.66406 33.2226H31.5043L31.3828 33.0535C28.8643 29.5495 24.6244 27.4448 20.0842 27.4448Z",
    fill: "#6CCC93"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8863 33.2226L33.0029 33.2037L32.4974 32.5004C31.0781 30.5258 28.9003 28.9829 26.6848 27.9428C27.8987 27.6163 29.1702 27.4448 30.4661 27.4448C35.0064 27.4448 39.2462 29.5495 41.7647 33.0535L41.8863 33.2226Z",
    fill: "#6CCC93"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.66406,
    y: 11.5562,
    width: 2.88889,
    height: 11.5556,
    fill: "#256AF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.33333 18.7783H15.8889V47.6672H5.77778L5.34864 45.0924C5.15523 43.9319 4.73004 42.8224 4.09843 41.8298C1.48483 37.7227 0.698121 32.7133 1.92695 28.0028L4.33333 18.7783Z",
    fill: "#256AF5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.556 30.333H39.7227L38.2782 33.2219H7.22266V47.6663H41.8893C41.8893 45.9607 43.0309 44.4661 44.6764 44.0173L45.9835 43.6609C48.2843 43.0334 49.9281 41.0075 50.0681 38.6268L50.556 30.333Z",
    fill: "#256AF5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.22266,
    y: 24.5552,
    width: 5.77778,
    height: 2.88889,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7.22266,
    y: 30.333,
    width: 5.77778,
    height: 2.88889,
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.0534,
    cy: 39.7218,
    rx: 2.16667,
    ry: 2.16667,
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.7253,
    cy: 39.7218,
    rx: 2.16667,
    ry: 2.16667,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.3854,
    cy: 39.7218,
    r: 2.16667,
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTongkang);
export default __webpack_public_path__ + "static/media/tongkang.dc2c92a2701ed47e5feb5dc27243cfd8.svg";
export { ForwardRef as ReactComponent };